module.exports = __webpack_public_path__ + "img/call-24px.da56e4aa.svg";